import { render } from "./ConfigurableRows.vue?vue&type=template&id=3c748d46"
import script from "./ConfigurableRows.vue?vue&type=script&lang=js"
export * from "./ConfigurableRows.vue?vue&type=script&lang=js"
script.render = render

export default script